// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getProp from "@insite/mobius/utilities/getProp";
import { headerSignInStyles } from "@keller/Overrides/Widgets/Common/HeaderSignIn";
import color from "@keller/XDL/Utilities/color";
import { styledScrollbar } from "@keller/XDL/Utilities/scroll";
import xScreen from "@keller/XDL/Utilities/xScreen";
import { css } from "styled-components";

headerSignInStyles.floatingTooltip = {
    tooltipContent: {
        css: css`
            max-width: ${({ isAuthenticated }: any) => (isAuthenticated ? "522px" : "388px")};
            height: fit-content;
            max-height: ${({ isAuthenticated, headerHeight }: any) =>
                !isAuthenticated ? "fit-content" : `calc(100vh - ${headerHeight ?? 152}px)`};
            z-index: ${getProp("theme.zIndex.modal")};
        `,
    },
    tooltipInnerContent: {
        css: css`
            scrollbar-gutter: stable;
            overflow-x: hidden;
            padding: 20px;
            max-height: inherit;
            ${styledScrollbar(2)}
        `,
    },
};
